import React from "react";
import Back from "../components/Back";
import Scanner from "../components/Scanner";

export default function ScanQR() {
  return (
    <div>
      <div className="container" />
      <Back title="Scan QR" reload={{ value: true, dest: "/scan" }} />
      <div className="content">
        <Scanner />
      </div>
    </div>
  );
}
